import React from 'react'
import { useAtom } from 'jotai'
import { analyticsCurrentAction } from '@store/atoms.ts'
import thank from '@assets/Thankyou_page.png'
import Header from './Header'

/**
 * ThankYouSimulatore
 * Uses the same page container as Simulatore so the header spacing matches.
 */
const ThankYouSimulatore: React.FC = () => {
	const [currentAnalytics, setCurrentAnalytics] = useAtom(
		analyticsCurrentAction
	)
	const exitUrl = import.meta.env.VITE_EXIT_URL
	const onExit = () => {
		window.location.href = exitUrl
	}

	return (
		<div className='w-full min-h-dvh flex flex-col bg-[linear-gradient(180deg,rgba(248,249,250,0)_17.59%,rgba(216,233,195,0.5)_135.26%)]'>
			<main className='flex-1'>
				<div className='w-full max-w-[1296px] mx-auto px-3 md:px-6 flex flex-col gap-2 md:gap-4'>
					<Header hideBackButton hideClose />

					<div className='w-full max-w-[850px] mx-auto px-3 md:px-6 flex flex-col'>
						<div className='flex flex-col items-center text-center gap-8'>
							<h2 className='text-(--primary-blue) text-[28px] md:text-[40px] font-semibold pb-2 md:pb-4'>
								A presto!
							</h2>

							<img src={thank} className='w-[180px] sm:w-[240px] md:w-80 h-auto mx-auto object-contain' alt='thank you' />
							<p className='md:text-[18px] pb-6 md:pb-8 pt-6 md:pt-8 text-(--text-secondary)'>
								Controlla la tua email, ti abbiamo inviato un link per riprendere da dove ti sei fermato e completare la tua richiesta.
							</p>

							<button
								className='w-fit font-bold md:px-4 px-5 py-3 md:py-2 rounded-[30px] transition text-white bg-(--green-default) bg-linear-to-r from-(--green-default) to-(--green-hover) shadow-[0_3px_10px_rgba(0,0,0,0.1)] hover:underline'
								onClick={onExit}
							>
								Torna alla homepage
							</button>
						</div>
					</div>
				</div>
			</main>
		</div>
	)
}

export { ThankYouSimulatore }
